import {
  apiWireTypeToActionTypeFilterValue,
  optLogDisplayTypeToApiWireType,
} from '~/shared/utils/optLogActionTypeMapping';

export type ActionTypeFilterValue =
  | 'Growth'
  | 'Shrink'
  | 'Modify'
  | 'Change Performance Tier'
  | 'Activate Autoscaling'
  | 'Deactivate Autoscaling'
  | '';

export const actionTypeValues = [
  'Growth',
  'Shrink',
  'Modify',
  'Change Performance Tier',
  'Activate Autoscaling',
  'Deactivate Autoscaling',
] as const satisfies readonly Exclude<ActionTypeFilterValue, ''>[];

/** Maps UI filter values to opt-log list/count `type` query param (API enum). */
export function actionTypeFilterToApiType(value: Exclude<ActionTypeFilterValue, ''>): string {
  return optLogDisplayTypeToApiWireType(value);
}

/** Maps API `type` query param values to UI filter values (bookmarks, shared links). */
export const apiWireActionTypeToFilterValue = apiWireTypeToActionTypeFilterValue as Record<
  string,
  Exclude<ActionTypeFilterValue, ''>
>;
